module.exports = __webpack_public_path__ + "static/adult_sapphire_dragon-3ecd4c91d8bcad41b0e9219743803b2a.jpg";